import { Controller } from "stimulus"
import TomSelect from "tom-select"

// 印表機編輯：行為層。DOM / 樣式 / label 都在 _printer_fields.html.erb。
// 每欄是一個可搜尋、可自行輸入（create）的 TomSelect，select 直接帶 name 送出
// （nested attributes：profile[printers_attributes][i][brand] / [model]，is_custom 由 server 推導）。
// 這裡只負責：clone 新列（替換 NEW_RECORD index）、品牌 -> 型號清單連動、
// TomSelect 接管、移除列（既有列標記 _destroy 後隱藏；新列直接移除節點）。
export default class extends Controller {
  static values = { catalog: Object, labels: Object }
  static targets = ["rows", "template"]

  connect() {
    // 隱藏欄位的 index 只需彼此不重複、且不與 server 渲染的序號衝突即可
    this.newRowIndex = Date.now()
    this.rowsTarget.querySelectorAll("[data-printer-row]").forEach((row) => this.setupRow(row))
  }

  add(event) {
    event.preventDefault()
    const fragment = this.templateTarget.content.cloneNode(true)
    const row = fragment.querySelector("[data-printer-row]")
    const index = this.newRowIndex++
    row.querySelectorAll("[name]").forEach((el) => { el.name = el.name.replace(/NEW_RECORD/g, index) })
    this.rowsTarget.appendChild(fragment)
    this.setupRow(row)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-printer-row]")
    const destroyFlag = row.querySelector("[data-role='destroy-flag']")
    this.destroySelects(row)

    if (destroyFlag) {
      // 既有列：保留節點讓 id + _destroy 一起送出，server 端才會刪除
      destroyFlag.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
  }

  setupRow(row) {
    this.enhance(this.el(row, "brand-select"))
    this.enhance(this.el(row, "model-select"))
    this.el(row, "brand-select").addEventListener("change", () => this.rebuildModelOptions(row))
  }

  // 品牌改變時重填型號清單（仍可自行輸入自訂型號）
  rebuildModelOptions(row) {
    const brand = this.el(row, "brand-select").value
    const models = this.catalogValue[brand] || []
    const modelSelect = this.el(row, "model-select")

    if (modelSelect.tomselect) modelSelect.tomselect.destroy()
    modelSelect.innerHTML = ""
    modelSelect.append(this.option("", this.labelsValue.select_model))
    models.forEach((model) => modelSelect.append(this.option(model, model)))
    this.enhance(modelSelect)
  }

  // 可搜尋 + 可自行輸入新值（清單沒有就打字新增）
  enhance(select) {
    const addCustom = this.labelsValue.add_custom
    return new TomSelect(select, {
      create: true,
      persist: false,
      allowEmptyOption: true,
      maxOptions: null,
      render: {
        // 打字時顯示本地化的新增提示，例如「新增『XYZ』」
        option_create: (data, escape) => {
          const text = addCustom ? addCustom.replace("{input}", escape(data.input)) : `Add ${escape(data.input)}`
          return `<div class="create">${text}</div>`
        }
      }
    })
  }

  destroySelects(row) {
    row.querySelectorAll("select").forEach((select) => select.tomselect && select.tomselect.destroy())
  }

  option(value, label) {
    const option = document.createElement("option")
    option.value = value
    option.textContent = label
    return option
  }

  el(row, role) {
    return row.querySelector(`[data-role='${role}']`)
  }
}
